export const blockIconsHardwareHeadsetMic = (
	<span className='material-symbols-outlined'>headset_mic</span>
);
